export default __webpack_public_path__ + "static/media/still-still-still.ea9ac556.png";